import React from 'react'
import NewFeaturePopup from './NewFeaturePopup'
import TabCredFailed from '../containers/authorised/addOns/rpa/tab/setting/TabCredFailed'
import { connect } from 'react-redux'

function AppPopUps(props) {
  const { tabConfig, tabAddOnCred } = props

  const failedTABCred = ((tabConfig?.status && tabConfig?.status !== 'inactive') && (tabAddOnCred?.status && tabAddOnCred?.status == 'failed' && (tabAddOnCred?.message === 'Credentials are valid.' || tabAddOnCred?.message === 'error while login into portal' || tabAddOnCred?.message === 'Invalid credentials.')))

  return (
    <>
      {/* {localStorage.getItem("User-Type") !== "non_admin" && <NewFeaturePopup />} */}
      {failedTABCred && <TabCredFailed />}
    </>
  )
}

const mapStateToProps = state => {
  const { organisation: { organisation }, tab } = state
  return {
    tabConfig: organisation?.add_ons_config?.type?.tab,
    tabAddOnCred: tab.tab_add_on?.config?.creds,
  }
}

export default connect(mapStateToProps)(AppPopUps);
